import { NgModule } from '@angular/core';
import { MaterialModule } from '../material.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DataTypesComponent } from '../data-types/data-types.component';
import { ProceduresComponent } from '../procedures/procedures.component';
import { DragScrollModule } from 'ngx-drag-scroll';
import { ZoneDatePipe } from '../utils/zone-date.pipe';
import { TermsOfUseTextComponent } from '../terms-of-use-text/terms-of-use-text.component';
import { RouterModule } from '@angular/router';
import { DataSyncComponent } from '../data-sync/data-sync.component';
import { YesNoQuestionComponent } from '../yes-no-question/yes-no-question.component';
import { YesNoQuestionBlockComponent } from '../yes-no-question-block/yes-no-question-block.component';
import { QuestionComponent } from '../question/question.component';
import { LengthPipe } from '../utils/length.pipe';
import { DefaultPipe } from '../utils/default.pipe';
import { FilesharesComponent } from '../fileshares/fileshares.component';
import { TruncatePipe } from '../utils/truncate.pipe';
import { DatabricksComponent } from '../databricks/databricks.component';
import { ChunkPipe } from '../utils/chunk.pipe';
import { DataUserComponent } from '../data-user/data-user.component';
import { UserGroupComponent } from '../user-group/user-group.component';
import { HistoryComponent } from '../history/history.component';
import { ReasonComponent } from '../history/reason/reason.component';
import { StatusComponent } from '../history/status/status.component';
import { CommentComponent } from '../history/comment/comment.component';
import { NgxFilesizeModule } from "ngx-filesize";
import { AllowNumbersOnlyDirective } from "../utils/allownumbersonly.directive";
import { DataLakesComponent } from '../data-lakes/data-lakes.component';
import { WorkItemTableComponent } from "../work-item-table/work-item-table.component";
import { FolderExplorerComponent } from "../data-lakes/folder-explorer/folder-explorer.component";
import { FolderDialogComponent } from "../data-lakes/folder-explorer/folder-dialog/folder-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    DragScrollModule,
    NgxFilesizeModule,
    RouterModule
  ],
  declarations: [
    DataTypesComponent,
    ProceduresComponent,
    TermsOfUseTextComponent,
    ZoneDatePipe,
    DataSyncComponent,
    YesNoQuestionComponent,
    YesNoQuestionBlockComponent,
    QuestionComponent,
    LengthPipe,
    DefaultPipe,
    ChunkPipe,
    TruncatePipe,
    FilesharesComponent,
    DatabricksComponent,
    DataUserComponent,
    UserGroupComponent,
    HistoryComponent,
    ReasonComponent,
    StatusComponent,
    CommentComponent,
    AllowNumbersOnlyDirective,
    DataLakesComponent,
    WorkItemTableComponent,
    FolderExplorerComponent,
    FolderDialogComponent
  ],
  exports: [
    DataTypesComponent,
    ProceduresComponent,
    TermsOfUseTextComponent,
    MaterialModule,
    DragScrollModule,
    ZoneDatePipe,
    DataSyncComponent,
    YesNoQuestionComponent,
    YesNoQuestionBlockComponent,
    QuestionComponent,
    LengthPipe,
    DefaultPipe,
    ChunkPipe,
    TruncatePipe,
    FilesharesComponent,
    DatabricksComponent,
    DataUserComponent,
    UserGroupComponent,
    HistoryComponent,
    NgxFilesizeModule,
    AllowNumbersOnlyDirective,
    DataLakesComponent,
    WorkItemTableComponent,
    FolderExplorerComponent,
    FolderDialogComponent
  ]
})
export class SharedModule { }
